import classNames from 'classnames';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@wix/design-system';
import { PageModeContext } from 'providers/PageMode/PageMode.provider';
import s from './SubscriptionPage.scss';
import { RootStore, withInjectedRootStore } from 'providers';
import { observer } from 'mobx-react';

interface SubscriptionSelectButtonProps {
  onCycleSelect(): void;
  className?: string;
  rootStore: RootStore;
}

export const SubscriptionSelectButtonComp: React.FC<
  SubscriptionSelectButtonProps
> = ({ onCycleSelect, className }) => {
  const { t } = useTranslation();

  return (
    <PageModeContext.Consumer>
      {({ theme }) => (
        <Button
          className={classNames(s.selectButton, theme, className)}
          size='large'
          dataHook='select-cycle'
          onClick={() => {
            onCycleSelect();
          }}
        >
          {t('subscription_btn.continue_to_checkout')}
        </Button>
      )}
    </PageModeContext.Consumer>
  );
};

export const SubscriptionSelectButton = withInjectedRootStore(
  observer(SubscriptionSelectButtonComp),
);
